import React from 'react'
import { Modal } from 'antd'
import {SnapList} from 'components/elements/ListEditor'
import {withRouter} from 'react-router-dom'

class SpeciesCards extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Delete Item',
      content: 'Are you sure to delete this item?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
      },
    })
  }
  

  render() {
    return (
      <SnapList
        data={this.props.dataSource || []}
        listType={'Species'}
        sortBy={'name'}
        createPrompt={'Create New Species'}
        initial={this.props.match.params.id}
        onSelect={this.props.onSelect}
        onCreate={this.props.onCreate}
        row={(props)=>(
          <div>
            {props.name}
          </div>
        )}
      />
    )
  }
}

export default withRouter(SpeciesCards)